import React from 'react'

export default class TinyLetterForm extends React.Component {
  submitForm() {
    window.open(
      'https://tinyletter.com/sunu',
      'popupwindow',
      'scrollbars=yes,width=800,height=600'
    )
    return true
  }

  render() {
    return (
      <form
        action='https://tinyletter.com/sunu'
        method='post'
        target='popupwindow'
        onSubmit={this.submitForm}
      >
        <input type='email' name='email' placeholder='you@abc.xyz' />
        <input className='submit' type='submit' value='Subscribe' />
      </form>
    )
  }
}
